import PropTypes from 'prop-types';
import {CopyPipettingValueMode} from 'constants/cardStateEnum';
import {parseMessage} from '../../../../../lib/stringHelper';
import PipettingProfileInputType from '../PipettingProfileInputType';

function PipettingItemCopyPipettingValueButton({copyPipettingValueMode, onClickAllTasks, onClickAllCards}) {
  const labelApplyTo = parseMessage('protocolEditor.taskList.pipettingProfile.applyTo');
  const labelAllTasks = parseMessage('protocolEditor.taskList.pipettingProfile.copyTaskButton');
  const labelAllCards = parseMessage('protocolEditor.taskList.pipettingProfile.copyTaskToAllButton');

  const tooltipAllTasks = parseMessage('protocolEditor.taskList.pipettingProfile.copyTaskTooltip');
  const tooltipAllCards = parseMessage('protocolEditor.taskList.pipettingProfile.copyTaskToAllTooltip');

  return (
    <div className="pipetting-profile__item__copy-pipetting-value">
      {labelApplyTo}
      <div className="pipetting-profile__item__copy-pipetting-value__buttons">
        <div style={{display: 'inline-flex'}}>
          <PipettingProfileInputType.Button
            label={labelAllTasks}
            onClick={onClickAllTasks}
            disabled={copyPipettingValueMode === CopyPipettingValueMode.TO_ALL_CARDS}
          />
          <PipettingProfileInputType.InfoTooltip tooltipLabel={tooltipAllTasks} />
        </div>
        <div style={{display: 'inline-flex'}}>
          <PipettingProfileInputType.Button
            label={labelAllCards}
            onClick={onClickAllCards}
            disabled={copyPipettingValueMode === CopyPipettingValueMode.TO_ALL_TASKS}
          />
          <PipettingProfileInputType.InfoTooltip tooltipLabel={tooltipAllCards} />
        </div>
      </div>
    </div>
  );
}

PipettingItemCopyPipettingValueButton.propTypes = {
  copyPipettingValueMode: PropTypes.string.isRequired,
  onClickAllCards: PropTypes.func.isRequired,
  onClickAllTasks: PropTypes.func.isRequired,
};

export default PipettingItemCopyPipettingValueButton;
